import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AboutUs } from './pages/AboutUs';
import { ClinicalServices } from './pages/ClinicalServices';
import { Treatments } from './pages/Treatments';
import { Education } from './pages/Education';
import { Blog } from './pages/Blog';
import { Resources } from './pages/Resources';
import { FAQs } from './pages/FAQs';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen w-full bg-gray-50" data-id="element-1">
        <Navigation data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<AboutUs data-id="element-7" />} data-id="element-6" />
          <Route path="/services" element={<ClinicalServices data-id="element-9" />} data-id="element-8" />
          <Route path="/treatments" element={<Treatments data-id="element-11" />} data-id="element-10" />
          <Route path="/education" element={<Education data-id="element-13" />} data-id="element-12" />
          <Route path="/blog" element={<Blog data-id="element-15" />} data-id="element-14" />
          <Route path="/resources" element={<Resources data-id="element-17" />} data-id="element-16" />
          <Route path="/faqs" element={<FAQs data-id="element-19" />} data-id="element-18" />
          <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
        </Routes>
        <Footer data-id="element-22" />
      </div>
    </BrowserRouter>;
}